export const KeyCodes = {
  ENTER: 13,
  SPACE: 32,
};

export const Keys = {
  ENTER: 'Enter',
};
